import { Form, Input } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { ErrorFinder } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';
export function ErrorFinderEditPage(props: {
  errorfinder?: ErrorFinder;
  onSaved: (errorfinder?: ErrorFinder) => void;
  onCancel: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.errorfinder) {
      apiClient
        .post('error-finders', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`error-finders/${props.errorfinder?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.errorfinder}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 20, message: 'En fazla 20 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
